<script lang="ts">
    import dayjs from "dayjs";
    import {Button, Heading, Modal} from "flowbite-svelte";
    import {roundToNearest15} from "$lib/utils/roundTime";

    export let showCheckOutModal = false;

    export let assignee;

    export let realTime = false;

    let aboveFourHours = true;
    let displayBreak = false;

    $: {
        if(showCheckOutModal){
            aboveFourHours = dayjs().diff(dayjs(assignee.actualStart.value),'hours') >= 4
            onScanCheckOut()
        } else {
            displayBreak = false;
        }
    }
    const onScanCheckOut = () => {
        if(realTime){
            assignee.actualEnd.value = new Date()
            assignee.actualEnd.stamp = (new Date()).getTime()
        } else {
            assignee.actualEnd.value = roundToNearest15();
            assignee.actualEnd.stamp = assignee.actualEnd.value.getTime()
        }
    }
    const makeCheckout = (pause: null|number) => {

    }
</script>
<Modal size="xl" bind:open={showCheckOutModal}>
    {#if aboveFourHours}
        <Heading tag="h2" class="text-center mt-5">Checkout</Heading>
        <div class="grid gap-3 grid-cols-3 my-10">
            {#if displayBreak}
                <Button class="h-36 grid" on:click={() => makeCheckout(15)}>
                    <div class="text-2xl">15 min</div>
                </Button>
                <Button class="h-36 grid" on:click={() => makeCheckout(30)}>
                    <div class="text-2xl">30 min</div>
                </Button>
                <Button class="h-36 grid" on:click={() => makeCheckout(45)}>
                    <div class="text-2xl">45 min</div>
                </Button>
            {:else }
                <Button class="h-36 grid" on:click={() => displayBreak = true}>
                    <div class="text-2xl">Mit Pause</div>
                </Button>
                <Button class="h-36 grid" on:click={() => makeCheckout(null)}>
                    <div class="text-2xl">Kein Pause</div>
                </Button>
                <Button color="dark" class="h-36 grid" on:click={() => showCheckOutModal = false}>
                    <div class="text-2xl">Weiterarbeiten</div>
                </Button>
            {/if}

        </div>
    {:else}
        <Heading tag="h3" class="text-center mt-5">Sie sind bereits eingecheckt</Heading>
        <p class="text-center text-xl">Möchten Sie auschecken?</p>
        <div class="grid gap-3 grid-cols-2 my-10">
            <Button class="h-36 grid" on:click={() => makeCheckIn('actual')}>
                <div>JA</div>
                <div class="text-2xl">Arbeitszeit: {dayjs().diff(dayjs(assignee.actualStart.value),'hours',true)}</div>
            </Button>
            <Button class="h-36 grid" on:click={() => showCheckOutModal = false}>
                <div>Nein,</div>
                <div class="text-2xl">Weiterarbeiten</div>
            </Button>
        </div>
    {/if}

</Modal>